import { render } from "./PreviewSideBar.vue?vue&type=template&id=23942ecb&scoped=true"
import script from "./PreviewSideBar.vue?vue&type=script&lang=js"
export * from "./PreviewSideBar.vue?vue&type=script&lang=js"

import "./PreviewSideBar.vue?vue&type=style&index=0&id=23942ecb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23942ecb"]])

export default __exports__